import { atom } from 'jotai';

const EMPTY_SKUS: ReadonlySet<string> = new Set<string>();

export const wishlistSkusAtom = atom<ReadonlySet<string>>(EMPTY_SKUS);

export const wishlistLoadingAtom = atom(true);

export const setWishlistSkuAtom = atom(
  null,
  (get, set, { sku, isOnWishlist }: { sku: string; isOnWishlist: boolean }) => {
    const current = get(wishlistSkusAtom);
    if (current.has(sku) === isOnWishlist) return;

    const next = new Set(current);
    if (isOnWishlist) {
      next.add(sku);
    } else {
      next.delete(sku);
    }
    set(wishlistSkusAtom, next);
  },
);
